import {FC} from 'react'
import {Row} from 'react-table'
import {DownloadRequestItem} from '../../core/_models'

type Props = {
  row: Row<DownloadRequestItem>
}

const CustomRow: FC<Props> = ({row}) => (
  <tr {...row.getRowProps()}>
    {row.cells.map((cell) => (
      <td {...cell.getCellProps()} key={`${row.id}-${cell.column.id}`}>
        {cell.render('Cell')}
      </td>
    ))}
  </tr>
)

export {CustomRow}
